'use strict';

export default class FilterDropdown {
  constructor() {

    $('.filter-dropdown--item').on('click', function() {

    	var selected = $(this).text(),
    	    filterList = $(this).closest('ul'),
            value = $(this).data('value'),
            $parent = $(this).parents(".filter-dropdown");

        $parent.find('.filter-dropdown--selected').text(selected);
        $parent.find('.filter-dropdown--selected').addClass("selected");
        $parent.find('.filter-dropdown--selected').attr('data-value', value );
        
    	filterList.removeClass('expande');

    });

    $('.filter-dropdown--selected').on('click', function() {
    	$(this).siblings().addClass('expande');
    });

    $('.filter-dropdown--title').on('click', function() {
        $(this).parent().removeClass('expande');
    });
  }
}
